<template>
    <div class="card">
        <Toolbar class="mb-4">
            <template slot="left">
                <label>HISTORIAL DE USUARIO</label>
            </template>
        </Toolbar>
        <Toolbar class="mb-4">
            <template slot="left">
                <div class="p-fluid p-grid col-md-12">
                    <div class="col-md-2">
                        <label for="anio">Año</label>
                        <Dropdown id="anio" 
                            :filter="false" 
                            :options="anioLista" 
                            v-model="anioSeleccionado"
                            optionLabel="anio" 
                            dataKey="id"
                            placeholder="Año">
                        </Dropdown>
                    </div>
                    <div class="col-md-2">
                        <label for="cedula">Cédula</label>
                        <InputText id="cedula" type="text" disabled v-model="cliente.cedula" />
                    </div>
                    <div class="col-md-2" >
                        <label for="nombres">Nombres</label>
                        <InputText id="cedula" type="text" disabled v-model="cliente.nombres" />
                    </div>
                    <div class="col-md-2">
                        <label for="nombres">No. medidor</label>
                        <InputText id="cedula" type="text" disabled v-model="cliente.numeroMedidor" />
                    </div>
                    <div class="col-md-2">
                        <label for="buscar">&nbsp;&nbsp;</label>
                        <div class="col-md-2">
                            <Button id="buscar" icon="pi pi-search" v-tooltip="'Buscar cliente'" style="width:50px;" class="p-button-primary" @click="buscarCliente()" />
                        </div>							
                    </div>
                    <div class="col-md-2">
                        <label for="buscar">&nbsp;&nbsp;</label>
                        <div class="col-md-2">
                            <Button id="buscar" icon="pi pi-file-pdf" v-tooltip="'Visualizar'" style="width:50px;" class="p-button-danger" @click='verReporte()' />
                        </div>							
                    </div>
                </div>
            </template>
        </Toolbar>
        <Dialog :visible.sync="clientesDialog" :style="{ width: '800px' }" :header="textocliente" :modal="true" class="p-fluid" position="top" @hide="cerrarDialogo">
            <div class="col-md-12 p-lg-12">
                <DataTable
                    class="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-responsive p-datatable-customers"
                    :value="dataCliente"
                    :rowHover="true"
                    dataKey="id"
                    :paginator="true"
                    :rows="8"
                    :filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Mostrar {first} hasta {last} de {totalRecords} Registros">
                    <template #header>
                        <div class="table-header">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filters['global']" placeholder="Buscar..." />
                            </span>
                        </div>
                    </template>
                    <template #empty> No se encontraron Registros. </template>
                    <template #loading> Cargando Registros, por favor espere un momento. </template>
                    <Column field="cedula" header="Cédula" headerStyle="width: 8em;">
                        <template #body="slotProps">
                            <span class="p-column-title"> Cédula:</span>
                            {{ slotProps.data.cedula }}
                        </template>
                    </Column>
                    <Column field="nombres" header="Nombres">
                        <template #body="slotProps">
                            <span class="p-column-title"> Nombres:</span>
                            <span  :class="'customer-badge'">{{ slotProps.data.nombres }} </span>
                        </template>
                    </Column>
                    <Column field="apellidos" header="Apellidos">
                        <template #body="slotProps">
                            <span class="p-column-title"> Apellidos:</span>
                            <span  :class="'customer-badge'"> {{ slotProps.data.apellidos }} </span>
                        </template>
                    </Column>
                    <Column field="telefono" header="Teléfono" headerStyle="width: 8em;">
                        <template #body="slotProps">
                            <span class="p-column-title"> Teléfono:</span>
                            <span  :class="'customer-badge'">{{ slotProps.data.telefono }} </span>
                        </template>
                    </Column>
                    <Column headerStyle="width: 5em;">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" @click="seleccionarCliente(slotProps.data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
            <template #footer>
                <Button label="Salir" icon="pi pi-times" class="p-button-warning p-mr-2" @click="cerrarDialogo()" />
            </template>
        </Dialog>
        <div>
            <embed :src="pdfRuta" type="application/pdf" width="100%" height="600px" />
        </div>
        <div class="p-grid p-fluid dashboard"> 
            <DialogProgreso
                :showProgreso="showProgreso"
                :titulo="mensajeCargando">
            </DialogProgreso>
        </div>
    </div>
</template>

<script>
import AnioService from "../../service/administracion/AnioService";
import ClienteService from "../../service/administracion/ClienteService";
import PlanillaService from "../../service/administracion/PlanillaService";
import DialogProgreso from "../componentesglobales/DialogoProgreso.vue";
import Swal from 'sweetalert2';

export default {
    data() {
        return {
            anioLista: [],
			anioSeleccionado: {},
            cliente: {},
            clientesDialog: false,
            textocliente: null,
            dataCliente: [],
            filters: {},
            position: "top",
            showProgreso: null,
            mensajeCargando: null,
        };        
    },
    anioService: null,
    clienteService: null,
    planillaService: null,
    created() {
        this.anioService = new AnioService();
        this.clienteService = new ClienteService();
        this.planillaService = new PlanillaService();
    },
    mounted() {
        this.cargarAnio();
        this.cargarClientes();
    },
    components: {
        'DialogProgreso': DialogProgreso,
    },
    
    methods: {
        cargarAnio(){
			this.anioLista = [];
			this.anioService.buscaractivos().then( response => {
				this.anioLista = response.data;
			}).catch( error => {
				console.log(error);
			});
		},

        cargarClientes(){
            this.dataCliente = [];
            this.clienteService.buscarClientesActivos().then((response) => {
                this.dataCliente = response.data;
            }).catch(() => {
            });
        },

        buscarCliente(){
            this.textocliente = "Listado de clientes";
            this.clientesDialog = true;
            this.filters = {};
            this.cliente = {};
        },

        seleccionarCliente(data){
            this.totalpagar = 0;
            Swal.fire({
                title: 'Cargando...',
                html: 'por favor, espere!...',
                allowOutsideClick: false,
                onBeforeOpen: () => {
                    Swal.showLoading()
                },
            });
            this.cliente = data;
            this.clientesDialog = false;
            Swal.close();
        },

        cerrarDialogo(){
            this.clientesDialog = false;
        },

        verReporte(){
            if(Object.keys(this.anioSeleccionado).length == 0){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe seleccionar año", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
			if(this.cliente == null){
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe seleccionar cliente", icon: 'warning', showConfirmButton: true, timer: 6000});
                return;
            }
            this.mensajeCargando = "Generando reporte";
            this.showProgreso = true;
            this.planillaService.imprimirHistorialUsuario(this.cliente.id, this.anioSeleccionado.anio).then(response => {
                var headers = response.headers;
                var blob = new Blob([response.data],{type:headers['content-type']});
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                this.showProgreso = false;
                this.pdfRuta = link.href;
            }).catch(() => {
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Documento no existe", icon: 'warning', showConfirmButton: true, timer: 6000});
                this.showProgreso = false;
            });
        }
    }
}
</script>
<style lang="scss" scoped>
    .table-header {
        display: flex;
        justify-content: space-between;
    }
    .p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
    display: none;
}
@media screen and (max-width: 960px) {
	/deep/ .p-datatable {
		&.p-datatable-customers {
			.p-datatable-thead > tr > th,
			.p-datatable-tfoot > tr > td {
				display: none !important;
			}
			.p-datatable-tbody > tr {
				> td {
					text-align: left;
					display: block;
					border: 0 none !important;
					width: 100% !important;
					float: left;
					clear: left;
					border: 0 none;
					.p-column-title {
						padding: .4rem;
						min-width: 30%;
						display: inline-block;
						margin: -.4rem 1rem -.4rem -.4rem;
						font-weight: bold;
					}
					.p-progressbar {
						margin-top: .5rem;
					}
				}
			}
		}
	}
}

    .buttonAzul{
        background-color: #14334d;
        color: #FFFFFF;
    }

    .buttonBlancoAzul{
        background-color: #FFFFFF;
        color: #14334d;
        border: 1px solid #14334d;
    }

    .buttonBlancoRojo{
        background-color: #FFFFFF;
        color: #d32f2f;
        border: 1px solid #d32f2f;
    }

    .buttonRojo{
        background-color: #d32f2f;
        color: #FFFFFF;
    }
    @media screen and (max-width: 960px) {
		/deep/ .p-datatable {
			&.p-datatable-customers {
				.p-datatable-thead > tr > th,
				.p-datatable-tfoot > tr > td {
					display: none !important;
				}

				.p-datatable-tbody > tr {
					border-bottom: 1px solid #dee2e6;
					> td {
						text-align: left;
						display: flex;
						align-items: center;
						justify-content: center;
						border: 0 none !important;
						width: 100% !important;
						float: left;
						clear: left;
						border: 0 none;

						.p-column-title {
							padding: .4rem;
							min-width: 30%;
							display: inline-block;
							margin: -.4rem 1rem -.4rem -.4rem;
							font-weight: bold;
						}

						.p-progressbar {
							margin-top: .5rem;
						}
					}
				}
			}
		}
	}
</style>